import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmPasswordValidator } from '../../../_common/_helper/confirm-password.validator';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from '../../../_common/_service/user.service';
import { HeaderComponent } from '../../../_Shared/header/header.component';

@Component({
  selector: 'app-updatereferencialCode',
  templateUrl: './updatereferencialCode.component.html',
  styleUrls: ['./updatereferencialCode.component.scss']
})
export class UpdatereferencialCodeComponent implements OnInit { 

  public UpdatereferencialCodeForm: FormGroup;
  submitted = false;
  currentUser: any;
  EmailId: any;

  constructor(
    private authService: AuthService,   
    public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService,
   
    private tokenStorageService: TokenStorageService,
    public dialogRef: MatDialogRef<UpdatereferencialCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.tokenStorageService.getEmployeeDetail2().subscribe(data => {
      
      if (data != "") {
        this.currentUser = data
  
      }
      else { this.currentUser = this.tokenStorageService.getUser(); }

 
    });
    
    this.UpdatereferencialCodeForm = this.fb.group({

      referencialCode: [null, [Validators.required]]
     
    })
  }

  ngOnInit() {
    this.EmailId = this.data;
  }

  get f() { return this.UpdatereferencialCodeForm.controls; }
  
  update(post:any) {
    
    this.submitted = true;
    if (this.UpdatereferencialCodeForm.valid) {

      this.authService.UpdatereferencialCode(post).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; }) => {
        
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
          this.dialogRef.close();

        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }
}
